import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Translations } from '../../core/services/translations.service';
import { ILanguageModel } from '../../shared/model/ilanguage-model';
import { NGXLogger } from 'ngx-logger';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'eos-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslateModule],
})
export class ErrorPageComponent implements OnInit {
  private logger = inject(NGXLogger);
  private translations = inject(Translations);

  errorPageLanguage: ILanguageModel['errorPage'];

  ngOnInit(): void {
    this.logger.debug('ErrorPageComponent.ngOnInit');
    this.errorPageLanguage = this.translations.errorPage;
  }
}
